import axios, { AxiosRequestConfig } from 'axios';
import { default as config } from '../constants/constants';

// Fetch user subscribed podcasts
export async function fetchSubscribedPodcasts(
  token: string,
  searchTerm: string,
  page: number,
  pageSize: number
) {
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts/fetchSubscribed`,
    params: {
      page: page,
      pageSize: pageSize,
      searchTerm: searchTerm
    }
  };
    const response = await axios(options);
    return response;
}
